import React, { useEffect } from "react";
import { Skeleton } from "@mantine/core";
import ColorBaseMap from "../../../libs/maps/ColourBaseMap"; // same component already used in ClassroomObservation.tsx
import { EButton } from "../../../libs/ui";
import InformationToolTip from "../../../libs/ui/src/Stat/InformationToolTip";
import { getAttendanceColor, getAttendanceStatus } from "../utils/attendanceStatus.util";

interface Props {
  title: string; // "Morning Attendance (Cutoff: 10 AM)"
  isLoading: boolean;
  data: any;
  reportLevel: any; // reuse the IReportLevel your other ColorBaseMap callers pass
  uniqueId: string;
  onViewDistrictList: () => void;
  onDownloadMap: () => void;
}

const LEGEND_ITEMS = [
  { label: "Good (≥ 90%)", color: "#22C55E" },
  { label: "Moderate (70% - 89%)", color: "#F5A524" },
  { label: "Poor (< 70%)", color: "#EF4444" },
  { label: "No Data", color: "#9CA3AF" },
];

export default function AttendanceHeatMapCard({
  title,
  isLoading,
  data,
  reportLevel,
  uniqueId,
  onViewDistrictList,
  onDownloadMap,
  type
}: any) {

const [newData, setNewData] = React.useState<{ Map: any[] }>({ Map: [] });
useEffect(() => {
  setNewData({
    Map: Array.isArray(data) ? [...data] : [],
    // OverAll: {
    //   name:"Total",
    //   Present: e?.eveningPresent ?? 0,
    //   Percentage: e?.eveningPercentage ?? 0,
    // },
  });
}, [data]);


  return (
    <div className="attendance-heatmap-card p-4 border rounded-lg">
      {isLoading ? (
        <Skeleton height={360} radius="md" />
      ) : (
        <div className="flex gap-4">
          <div className="flex-1">
            <ColorBaseMap
              mapData={
                newData?.Map?.map((e: any) => ({
                  name: e?.name,
                  value: e?.Percentage ?? 0,
                })) ?? []
              }
              colorFn={getAttendanceColor}
              overAllStats={{
                label: title,
                value: undefined, // no single overall %, table below carries per-district detail
                overAll: undefined,
                toolTipLabel: `% teachers present, ${title}`,
              }}
              selectedDistrict={reportLevel?.districtName || ""}
              reportLevel={reportLevel}
              uniqueId={uniqueId}
              downloadableData={newData || []}
            />
          </div>

          <div className="flex flex-col gap-2 justify-center text-sm w-40">
            {LEGEND_ITEMS.map((item) => (
              <div key={item.label} className="flex items-center gap-2">
                <span
                  className="inline-block w-3 h-3 rounded-full"
                  style={{ backgroundColor: item.color }}
                />
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* <div className="flex justify-between mt-4">
        <EButton variant="subtle" onClick={onViewDistrictList}>
          View District List
        </EButton>
        <EButton variant="default" onClick={onDownloadMap}>
          Download Map
        </EButton>
      </div> */}
    </div>
  );
}
